const INITIAL_STATE = {
  user: null,
  users: []
}

const userReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case 'SET_USER':
      return {
        ...state,
        user: action.payload
      }
    case 'FETCH_USERS':
      return {
        ...state,
        users: action.payload
      }
    default:
      return state
  }
}

export default userReducer
